import React, { useState, useEffect } from "react";

// 可重用的浮動功能按鈕，帶進出場動畫
const FabActionButton = ({ label, icon, onClick, index = 0, visible }) => (
  <button
    className={`mb-2 w-14 h-14 rounded-full bg-amber-700 text-white text-2xl font-bold shadow-2xl hover:bg-amber-600 transition-all duration-200 border-4 border-[#23272f] flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-amber-400
      ${
        visible
          ? "opacity-100 translate-y-0 animate-fab-fadein pointer-events-auto"
          : "opacity-0 translate-y-4 animate-fab-fadeout pointer-events-none"
      }`}
    style={{
      animationDelay: `${index * 30}ms`,
      animationFillMode: "forwards",
    }}
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log("[FabActionButton] onMouseDown", label);
    }}
    onClick={() => {
      console.log("[FabActionButton] onClick", label);
      if (typeof onClick === "function") onClick();
    }}
    aria-label={label}
    tabIndex={0}
  >
    {icon && <span className="text-2xl">{icon}</span>}
    {/* 僅在寬螢幕顯示文字，手機僅顯示 icon，提升一致性與簡潔度 */}
    <span className="hidden md:inline text-base font-bold ml-2">{label}</span>
  </button>
);

const FabGroup = ({
  setShowControls,
  routes,
  shouldShowControls,
  randomRestaurant,
  setRandomRestaurant,
  onRandomRestaurant, // <-- 加入解構
  onTreasure,
  open,
  setOpen,
  isLoggedIn,
}) => {
  const [showButtons, setShowButtons] = useState(false);
  // 用戶座標 state
  const defaultCenter = { lat: 22.3193, lng: 114.1694 };
  const [userLocation, setUserLocation] = useState(defaultCenter);

  // 取得用戶地理位置
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setUserLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
          console.debug("[FabGroup] 取得用戶座標", pos.coords);
        },
        (err) => {
          console.warn("[FabGroup] 取得用戶座標失敗", err);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    } else {
      console.warn("[FabGroup] 瀏覽器不支援 geolocation");
    }
  }, []);

  // 控制展開/收合動畫 timing
  useEffect(() => {
    if (open) {
      setShowButtons(true);
    } else if (showButtons) {
      const t = setTimeout(() => setShowButtons(false), 180);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line
  }, [open, showButtons]);

  // 防止 FabGroup 收合時自動關閉餐廳資訊卡
  // 只允許 setRandomRestaurant(null) 由 X 按鈕觸發
  // 若父層 unmount FabGroup，state 會被重置，導致資訊卡消失
  // 建議：將 randomRestaurant 狀態提升至父層（如 App.js 或主頁），
  // 並以 props 傳入 FabGroup，這樣 FabGroup unmount 也不會影響資訊卡顯示

  // --- 以下為建議修改範例 ---
  // 1. 父層：
  // const [randomRestaurant, setRandomRestaurant] = useState(null);
  // <FabGroup ... randomRestaurant={randomRestaurant} setRandomRestaurant={setRandomRestaurant} />
  //
  // 2. FabGroup 內部：
  // props 接收 randomRestaurant, setRandomRestaurant
  // 移除 FabGroup 內部 useState(randomRestaurant)
  //
  // 3. 其他邏輯不變
  //
  // 這樣即使 FabGroup 被 unmount，randomRestaurant 狀態仍保留，資訊卡不會因 FabGroup 收合而消失。

  // render log
  console.debug("[FabGroup] render", {
    shouldShowControls,
    routesLength: routes.length,
    open,
    showButtons,
  });
  // if (routes.length === 0) return null; // 讓FabGroup永遠顯示
  return (
    <div className="fixed bottom-8 right-8 z-[1010] flex flex-col items-end gap-3">
      {/* 動畫區塊 */}
      <style>{`
        @keyframes fab-fadein {
          0% { opacity: 0; transform: translateY(24px) scale(0.95); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes fab-fadeout {
          0% { opacity: 1; transform: translateY(0) scale(1); }
          100% { opacity: 0; transform: translateY(24px) scale(0.95); }
        }
        .animate-fab-fadein {
          animation: fab-fadein 0.18s cubic-bezier(0.4,0,0.2,1) both;
        }
        .animate-fab-fadeout {
          animation: fab-fadeout 0.18s cubic-bezier(0.4,0,0.2,1) both;
        }
        @keyframes fadein-up-card {
          0% { opacity: 0; transform: translateY(32px) scale(0.95); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes fadeout-down-card {
          0% { opacity: 1; transform: translateY(0) scale(1); }
          100% { opacity: 0; transform: translateY(32px) scale(0.95); }
        }
        .animate-fadein-up-card {
          animation: fadein-up-card 0.22s cubic-bezier(0.4,0,0.2,1) both;
        }
        .animate-fadeout-down-card {
          animation: fadeout-down-card 0.22s cubic-bezier(0.4,0,0.2,1) both;
        }
      `}</style>
      {showButtons && !shouldShowControls && (
        <div className="flex flex-row-reverse items-end gap-4">
          {/* FabGroup 按鈕區（右側） */}
          <div className="flex flex-col items-end">
            <FabActionButton
              // label="顯示控制面板"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  fill="none"
                  className="w-7 h-7"
                >
                  {/* 綠色方形地圖底圖 */}
                  <rect
                    x="4"
                    y="7"
                    width="24"
                    height="18"
                    rx="4"
                    fill="#22c55e"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                  {/* 藍色湖泊（加大、加深色、加描邊） */}
                  <ellipse
                    cx="12"
                    cy="16"
                    rx="4.2"
                    ry="3.2"
                    fill="#0ea5e9"
                    stroke="#2563eb"
                    strokeWidth="1.2"
                    opacity="0.95"
                  />
                  <ellipse
                    cx="21"
                    cy="13"
                    rx="2.7"
                    ry="1.7"
                    fill="#0ea5e9"
                    stroke="#2563eb"
                    strokeWidth="1.2"
                    opacity="0.85"
                  />
                  {/* 藍色河流（曲線） */}
                  <path
                    d="M8 20 Q13 17 16 14 Q19 12 24 10"
                    stroke="#38bdf8"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                    opacity="0.85"
                  />
                  {/* 紅色曲線路線（多點貝茲曲線）*/}
                  <path
                    d="M7 22 Q12 10 16 18 Q20 26 25 12"
                    stroke="#ef4444"
                    strokeWidth="2.5"
                    fill="none"
                    strokeLinecap="round"
                  />
                  {/* 起點圓 */}
                  <circle
                    cx="7"
                    cy="22"
                    r="2.2"
                    fill="#22d3ee"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                  {/* 終點圓 */}
                  <circle
                    cx="25"
                    cy="12"
                    r="2.2"
                    fill="#f87171"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                  {/* 地圖定位點 */}
                  <circle cx="16" cy="18" r="1.5" fill="#fff" opacity="0.7" />
                </svg>
              }
              onClick={() => {
                console.debug("[FabGroup] 點擊顯示控制面板");
                setShowControls(true);
              }}
              index={0}
              visible={open}
            />
            <FabActionButton
              // label="隨機餐廳"
              icon={
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="rotate(18 18 18)">
                    {/* 放大且順時針旋轉的雞腿主體 */}
                    <ellipse
                      cx="23"
                      cy="18"
                      rx="10.5"
                      ry="8.2"
                      fill="#fbbf24"
                      stroke="#23272f"
                      strokeWidth="2.2"
                    />
                    {/* 雞腿陰影 */}
                    <ellipse
                      cx="23"
                      cy="22.2"
                      rx="7"
                      ry="2.7"
                      fill="#f59e42"
                      opacity="0.5"
                    />
                    {/* 雞腿骨頭，順時針傾斜 */}
                    <rect
                      x="8.5"
                      y="17.5"
                      width="12"
                      height="4"
                      rx="2"
                      fill="#fff"
                      stroke="#23272f"
                      strokeWidth="1.7"
                      transform="rotate(-2 8.5 17.5)"
                    />
                    {/* 骨頭圓頭 */}
                    <circle
                      cx="6.5"
                      cy="19"
                      r="2.1"
                      fill="#fff"
                      stroke="#23272f"
                      strokeWidth="1.3"
                    />
                    <circle
                      cx="9.2"
                      cy="22.2"
                      r="1.4"
                      fill="#fff"
                      stroke="#23272f"
                      strokeWidth="1"
                    />
                  </g>
                </svg>
              }
              onClick={onRandomRestaurant}
              index={1}
              visible={open}
            />
            {isLoggedIn && (
              <FabActionButton
                // label="藏寶"
                icon={
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    {/* 寶箱箱身 */}
                    <rect
                      x="6"
                      y="16"
                      width="20"
                      height="8"
                      rx="3"
                      fill="#c47f2b"
                      stroke="#23272f"
                      strokeWidth="2"
                    />
                    {/* 寶箱蓋子（分離且有厚度） */}
                    <rect
                      x="6"
                      y="10"
                      width="20"
                      height="7"
                      rx="3.5"
                      fill="#e2b86b"
                      stroke="#23272f"
                      strokeWidth="2"
                    />
                    {/* 蓋子陰影 */}
                    <rect
                      x="6"
                      y="15"
                      width="20"
                      height="2"
                      rx="1"
                      fill="#bfa76a"
                      opacity="0.5"
                    />
                    {/* 鎖扣 */}
                    <rect
                      x="14"
                      y="20"
                      width="4"
                      height="4"
                      rx="1"
                      fill="#fffbe6"
                      stroke="#23272f"
                      strokeWidth="1.2"
                    />
                    <circle
                      cx="16"
                      cy="22"
                      r="0.9"
                      fill="#c47f2b"
                      stroke="#23272f"
                      strokeWidth="0.7"
                    />
                    {/* 金幣 */}
                    <ellipse
                      cx="11"
                      cy="22"
                      rx="1.2"
                      ry="0.6"
                      fill="#ffd700"
                      stroke="#c47f2b"
                      strokeWidth="0.5"
                    />
                    <ellipse
                      cx="21"
                      cy="22.5"
                      rx="1"
                      ry="0.5"
                      fill="#ffd700"
                      stroke="#c47f2b"
                      strokeWidth="0.5"
                    />
                    <ellipse
                      cx="16"
                      cy="20.5"
                      rx="0.8"
                      ry="0.4"
                      fill="#ffd700"
                      stroke="#c47f2b"
                      strokeWidth="0.5"
                    />
                  </svg>
                }
                onClick={() => {
                  const loc =
                    userLocation && userLocation.lat && userLocation.lng
                      ? userLocation
                      : defaultCenter;
                  console.debug("[FabGroup] onClick 藏寶，userLocation:", loc);
                  setOpen(false); // 按下藏寶後自動收合 FabGroup
                  if (typeof onTreasure === "function") {
                    console.debug("[FabGroup] 呼叫 onTreasure callback");
                    onTreasure(loc);
                  } else {
                    console.warn(
                      "[FabGroup] onTreasure 不是 function",
                      onTreasure
                    );
                  }
                }}
                index={2}
                visible={open}
              />
            )}
          </div>
        </div>
      )}
      {!shouldShowControls && (
        <button
          className={`w-14 h-14 rounded-full bg-amber-700 text-white text-3xl font-bold shadow-2xl flex items-center justify-center hover:bg-amber-600 transition-all duration-300 border-4 border-[#23272f] focus:outline-none focus:ring-2 focus:ring-amber-400 ${
            open ? "rotate-45" : ""
          }`}
          style={{ transition: "transform 0.3s cubic-bezier(0.4,0,0.2,1)" }}
          onClick={() => {
            console.debug("[FabGroup] 點擊主功能選單＋，open:", !open);
            setOpen((o) => !o);
          }}
          aria-label="主功能選單"
        >
          <span role="img" aria-label="plus">
            ＋
          </span>
        </button>
      )}
    </div>
  );
};

// PropTypes 檢查與預設值，避免 setRandomRestaurant 未傳入時出錯
FabGroup.defaultProps = {
  randomRestaurant: null,
  setRandomRestaurant: () => {},
  onTreasure: () => {}, // 新增預設空函式
};

export default FabGroup;
